import React, { useEffect, useState } from "react";
import "./LoginForm.css";
import { FaUser, FaLock } from "react-icons/fa";
import { Form, Input, Button, Checkbox, Select } from "antd";
import { toast } from "react-toastify";
import OtpModal from "../Admin/AdminComponent/OtpModal";
import WfhVerification from "../Component/WfhVerification";
import { callApi } from "../../config/apiCall";
import { Api, BaseUrl } from "../Config/Api";
import { useLocation, useNavigate, useParams } from "react-router-dom";

const { Option } = Select;

export const LoginForm = () => {
  const [modalOpen, setModalOpen] = useState(false);
  const [modalOpen1, setModalOpen1] = useState(false);
  const [employeeData, setEmployeeData] = useState();
  const [isloding, setLoading] = useState(false);
  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);

  const company_id = queryParams.get('company_id');
  console.log("params", company_id);

  const fcmToken = sessionStorage.getItem("fcmToken");
  const details = JSON.parse(sessionStorage.getItem("userDetails")) || {}
  const navigate = useNavigate()
  useEffect(() => {
    if (details.token) {
      navigate(-1)
    }
  }, [])


  const onFinish = async (values) => {
    setLoading(true)
    const data = new FormData();
    data.append("email", values.username);
    data.append("password", values.password);
    data.append("type", values.role);
    data.append("company_id", values.company_id);
    data.append("fcm_token", fcmToken);//fcm_token:fcmToken

    // data.append("token" ,token )
    try {
      const response = await callApi(
        `${BaseUrl}${Api.LOGIN}`,
        "POST",
        data,
        ""
      );
      // //console.log("response", response);
      setLoading(false)
      if (response?.valid) {
        if (response?.success) {
          // what is the role of isOffice
          if (response?.isOffice === true) {
            if (response?.type === "Employee") {
              toast.success(response?.mssg);
              const token = response?.token;
              sessionStorage.setItem("authToken", token);
              sessionStorage.setItem("employeeId", response?.id);
              sessionStorage.setItem(
                "userDetails",
                JSON.stringify({
                  token,
                  user: response,
                  company_id: values.company_id,
                })
              );
              window.location = "/employee/";
            } else {
              // setEmployeeresponse(response);
              console.log("response" ,response); 
              
              if (response?.isFcmSame) {
                const token = response?.token;
                sessionStorage.setItem("authToken", token);
                sessionStorage.setItem("employeeId", response?.id);
                toast.success(response?.mssg);
                sessionStorage.setItem(
                  "userDetails",
                  JSON.stringify({
                    token,
                    user: response,
                    company_id: response?.company_id
                  })
                );
                window.location = "/admin/"
              } else {
                setEmployeeData({ ...response, company_id: values.company_id });
                setModalOpen(true);
              }

            }
            // toast.success(response.mssg || response.mssg || "Login Done");
          } else {
            if (response?.isAdmin == false && response?.isOffice == false) {

              setEmployeeData(values); //Employee
              setModalOpen1(true);
            } else {
              setEmployeeData(response); //admin
              setModalOpen(true);
            }
          }
        } else {
          toast.error(response.mssg || response.mssg || "Login Done");
        }
      } else {
        toast.error(response?.mssg[0] || response?.mssg || "Login Done");
      }
      
    } catch (error) {
      setLoading(false)
      toast.error(
        error?.response?.data?.error || error?.message || "Login Done"
      );
    }
  };

  const onFinishFailed = (errorInfo) => {
    setLoading(false)
    //console.log("Failed:", errorInfo);
  };



  return (
    <div className="login-page">
      <div className="login-box">
        <div className="illustration-wrapper">
          <img
            src={"/assets/Assets/test3.png"}
            alt="Login"
            style={{
              objectFit: "cover",
            }}
          />
        </div>
        <Form
          name="login-form"
          initialValues={{ remember: true }}
          onFinish={(e) => {
            if (!isloding) {
              onFinish(e)
            }
          }}
          onFinishFailed={onFinishFailed}
        >
          <div style={{
            display: "inline-grid",
            alignItems: "center",
            justifyContent: "center"
          }} className="form-title d-flex  gap- ">
            <p style={{ fontSize: "26px", marginBottom: "6px" }}>
              Welcome to
            </p>
            <span>
              <img src="/assets/img/logoNew.png" className="w-35 " />
            </span>
            {/* CV infotech Hr Management */}
          </div>

          <Form.Item
            name="username"
            rules={[
              {
                required: true,
                message: "Please input your email address",
              },
              {
                type: "email",
                message: "Please enter a valid email address",
              },
            ]}
          >
            <Input
              // value={username}
              // onChange={handleUsernameChange}
              placeholder="Username"
              prefix={<FaUser />}
            />
          </Form.Item>
          <Form.Item
            name="password"
            rules={[{ required: true, message: "Please input your password!" }]}
          >
            <Input.Password placeholder="Password" prefix={<FaLock />} />
          </Form.Item>
          <Form.Item
            name="role"
            rules={[{ required: true, message: "Please select a role!" }]}
          >
            <Select placeholder="Select a role">
              <Option value="Admin">Admin</Option>
              <Option value="Employee">Employee</Option>
            </Select>
          </Form.Item>
          <Form.Item
            name="company_id"
            // defa
            rules={[
              { required: true, message: "Please input your company id" },
            ]}
            className="uniform-input"
          >
            <Input placeholder="Company Id" />
          </Form.Item>

          <Form.Item name="remember" valuePropName="checked">
            <Checkbox>Remember me</Checkbox>
          </Form.Item>

          <Form.Item>
            <Button
              type="primary"
              htmlType="submit"
              className="login-form-button"
            >
              {isloding ? "Loading..." : "LOGIN"}
            </Button>
          </Form.Item>
        </Form>
      </div>
      <OtpModal
        open={modalOpen}
        onClose={() => setModalOpen(false)}
        employeeData={employeeData}
      />
      <WfhVerification
        open={modalOpen1}
        onClose={() => setModalOpen1(false)}
        employeeData={employeeData}
      />
    </div>
  );
};
